import $ from 'jquery';
import hcSticky from 'hc-sticky';

document.addEventListener('DOMContentLoaded', function () {
    new hcSticky('.blog-widgets-wrapper', {
        top: 120,
    });
});

$('.order-widget-select').on('change', function () {
    const $this = $(this);
    const val = $this.val();

    window.location = val;
});
